@use '@design/design-tokens/typography/typography' as *;

.contextHeaderContainer {
  display: flex;
  flex-direction: row;
  padding: 10px 16px;
  align-items: center;
  border-bottom: 1px solid var(--border-soft);
  width: 100%;
}

.styledToggle {
  [data-toggle-container] {
    height: 12px;
    width: 22px;
  }

  [data-toggle-circle] {
    width: 9px;
    height: 9px;
  }

  [data-toggle-icon] {
    width: 7px;
    height: 7px;
  }
}

.headerTextWrapper {
  display: flex;
  gap: 0.35em;
  padding-right: 8px;
}

.headerTextDefault {
  @include typography-v2-body-xs;
}

.headerTextPrimary {
  @include typography-v2-body-xs;
  color: var(--text-primary);
}

.headerTextDisabled {
  @include typography-v2-body-xs;
  color: var(--text-disabled);
}
